export var wrapper = 'relative rounded-full cursor-pointer';
export var camaraWrapper = 'rounded-full -top-1 -right-1 z-1 bg-white absolute p-1';
export var iconColor = 'text-primary';
export var getCameraIconSize = function (size) {
    switch (size) {
        case 'xs':
            return {
                height: '6px',
                width: '6px',
            };
        case 'sm':
            return {
                height: '8px',
                width: '8px',
            };
        case 'md':
            return {
                height: '10px',
                width: '10px',
            };
        case 'md-lg':
            return {
                height: '12px',
                width: '12px',
            };
        case 'header':
            return {
                height: '30px',
                width: '30px',
            };
        case 'lg':
        default:
            return {
                height: '14px',
                width: '14px',
            };
    }
};
//# sourceMappingURL=profile-avatar.styles.js.map